import { render, staticRenderFns } from "./HeatmapSettings.vue?vue&type=template&id=670befc6&scoped=true&"
import script from "./HeatmapSettings.vue?vue&type=script&lang=js&"
export * from "./HeatmapSettings.vue?vue&type=script&lang=js&"
import style0 from "./HeatmapSettings.vue?vue&type=style&index=0&id=670befc6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670befc6",
  null
  
)

export default component.exports